import {
	IconSize50,
	IconSize75,
	IconSize100,
	IconSize150,
	IconSize200,
	IconSize300,
	IconSize400,
	IconSize500,
	IconSize625,
	IconSize750,
} from "@mv/design-tokens/variables";
import { type SVGProps } from "react";
export interface Props
	extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
	size?:
		| "50"
		| "75"
		| "100"
		| "150"
		| "200"
		| "300"
		| "400"
		| "500"
		| "625"
		| "750";
}
const sizeMap = {
	50: IconSize50,
	75: IconSize75,
	100: IconSize100,
	150: IconSize150,
	200: IconSize200,
	300: IconSize300,
	400: IconSize400,
	500: IconSize500,
	625: IconSize625,
	750: IconSize750,
};
export default function IconCookies({ size = "100", ...props }: Props) {
	return (
		<svg
			xmlns={"http://www.w3.org/2000/svg"}
			{...props}
			viewBox="0 0 24 24"
			width={sizeMap[size]}
			height={sizeMap[size]}
		>
			<g fill="none" fillRule="evenodd" transform="scale(.6)">
				<circle cx={10.741} cy={18.148} r={2.593} fill="#D0021B" />
				<circle cx={17.037} cy={11.852} r={1.481} fill="#FFF" />
				<circle cx={19.259} cy={20} r={1.481} fill="#FFF" />
				<circle cx={25.556} cy={29.259} r={2.593} fill="#FFF" />
				<circle cx={12.593} cy={28.148} r={2.222} fill="#D0021B" />
				<circle cx={30.37} cy={8.889} r={1.481} fill="#D0021B" />
				<circle cx={32.963} cy={1.852} r={1.852} fill="#D0021B" />
				<circle cx={38.889} cy={11.481} r={1.111} fill="#D0021B" />
				<path
					fill="#FFF"
					fillRule="nonzero"
					d="M19.63 40c10.84 0 19.63-8.809 19.63-19.675 0-5.378-2.457 1.882-7.057-4.064-1.426-1.844-3.545 1.993-7.181-1.036-4.421-3.682.164-7.551-1.546-8.12C17.321 5.054 24.782.74 19.63.74 8.788.74 0 9.458 0 20.325 0 31.19 8.788 40 19.63 40m-.96-35.635c-.07 1.813.85 3.26 2.658 4.232-.93 2.876-.772 5.222 1.443 7.561q.378.399.828.774c2.33 1.94 4.343 2.089 6.856 1.265l.36-.117c2.034 2.43 4.047 3.187 6.213 2.82-.303 9.374-7.978 16.878-17.398 16.878-9.613 0-17.408-7.813-17.408-17.453 0-9.377 7.386-16.97 16.68-17.347a5.6 5.6 0 0 0-.232 1.387"
				/>
			</g>
		</svg>
	);
}
